export const CONTACT_EMAIL = "nikhil.joshi1205@example.com";
export const SITE_URL = "https://whynikhil.xyz";
